const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');
const { connect } = require('react-redux');
const { formatText } = require('core/i18n').i18n;
const {
    closed: glossaryClosed,
    opened: glossaryOpened,
} = require('actions/glossary');
const GlossaryAlphabetIndex = require('./GlossaryAlphabetIndex');
const GlossaryDefinitionTab = require('./GlossaryDefinitionTab');
const GlossaryFooter = require('./GlossaryFooter');
const GlossaryInput = require('./GlossaryInput');
const GlossaryResultsList = require('./GlossaryResultsList');
require('./Glossary.scss');
require('./GlossaryOverrideMobile.scss');

const ESC_KEY_CODE = 27;

/**
 * Glossary in the form of a sliding in modal.
 * It's connected to store.
 * Animated.
 * Closes on esc key pressed.
 * Closes on blank space clicked.
 **/
class Glossary extends React.Component {
    constructor(props) {
        super(props);
        this.handleEsc = this.handleEsc.bind(this);
    }

    componentDidMount() {
        document.addEventListener('keyup', this.handleEsc, false);
    }

    componentWilUnmount() {
        document.removeEventListener('keyup', this.handleEsc, false);
    }

    handleEsc(ev) {
        const { closeGlossary } = this.props;
        if (ev.keyCode === ESC_KEY_CODE) { closeGlossary(); }
    }

    render() {
        const { closeGlossary, isOpen, openGlossary } = this.props;
        return (
            <div
                className="glossary"
                style={{ right: isOpen ? 0 : -300 ,
                         display: isOpen ? 'initial' : 'none' }}
            >
                <div
                    className={classNames('glossary__wrapper', { 'slide__in--right': isOpen, 'slide__in--left': !isOpen })}
                >
                    <div className="glossary__header">
                        <div
                            className="header--close"
                            onClick={() => closeGlossary()}
                        />
                        <h2 className="header--title">{formatText('glossary-header')}</h2>
                        <GlossaryInput isVisible={isOpen} />
                    </div>
                    <div className="glossary__container">
                        <GlossaryResultsList />
                        <GlossaryAlphabetIndex />
                        <GlossaryDefinitionTab />
                    </div>
                    <GlossaryFooter />
                </div>
                <div
                    className="glossary__background"
                    onClick={() => isOpen ? closeGlossary() : openGlossary()}
                    role="presentation"
                    style={{
                        width: isOpen ? '100%' : 0,
                        opacity: isOpen ? 0.5 : 0,
                    }}
                />
            </div>
        );
    }
}


Glossary.propTypes = {
    closeGlossary: PropTypes.func.isRequired,
    isOpen: PropTypes.bool.isRequired,
    openGlossary: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
    isOpen: state.glossary.isOpen,
    selectedDefinition: state.glossary.selectedDefinition,
});

const mapDispatchToProps = dispatch => ({
    closeGlossary: () => dispatch(glossaryClosed()),
    openGlossary: () => dispatch(glossaryOpened()),
})


module.exports = connect(mapStateToProps, mapDispatchToProps)(Glossary);
